import {HttpModelConverter} from "../../../../../../../core/converter/httpModel.converter";
import {Injectable} from "@angular/core";
import {PermissionsConverter} from "../../../../../../../common/converter/permissions.converter";
import {TreatmentJourneyStepSummaryModel} from "./treatmentJourneyStepSummary.model";
import {DateConverter} from "../../../../../../../common/converter/date.converter";
import {
    LovValueSummaryConverter
} from "../../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";
import {TreatmentJourneyStepTriggerConverter} from "./treatmentJourneyStepTrigger.converter";
import {ValueAndLabelConverter} from "../../../../../../../common/converter/ValueAndLabel.converter";

@Injectable({
    providedIn: 'root'
})
export class TreatmentJourneyStepSummaryConverter extends HttpModelConverter<TreatmentJourneyStepSummaryModel> {

    constructor(private permissionConverter: PermissionsConverter,
                private momentConverter: DateConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter,
                private treatmentJourneyStepTriggerConverter: TreatmentJourneyStepTriggerConverter,
                private valueAndLabelConverter: ValueAndLabelConverter) {
        super();
    }

    protected createInstance(): TreatmentJourneyStepSummaryModel {
        return new TreatmentJourneyStepSummaryModel();
    }

    protected enrichObject(result: TreatmentJourneyStepSummaryModel, src: TreatmentJourneyStepSummaryModel) {
        result.permissions = this.permissionConverter.convert(src.permissions);
        result.start = this.momentConverter.convert(src.start);
        result.end = this.momentConverter.convert(src.end);
        result.type = this.lovValueSummaryConverter.convert(src.type);
        result.trigger = this.treatmentJourneyStepTriggerConverter.convert(src.trigger);
        result.errors = this.valueAndLabelConverter.convertFromArray(src.errors);
    }
}